import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

export const visitScheduleV1Schema = z.object({
  visitId: entityIdSchema,
  serviceOrderId: entityIdSchema,
  startsAt: z.iso.datetime({ offset: true }),
  endsAt: z.iso.datetime({ offset: true }),
  timezone: z.string().min(1).max(64),
  assignedWorkerId: entityIdSchema.nullable(),
  assignedCrewId: entityIdSchema.nullable(),
}).strict().refine((value) => value.startsAt < value.endsAt, {
  path: ["endsAt"],
  message: "Visit must end after it starts.",
}).refine(
  (value) =>
    (value.assignedWorkerId === null) !== (value.assignedCrewId === null),
  {
    path: ["assignedWorkerId"],
    message: "Visit must have exactly one worker or crew assignment.",
  },
)

export const visitRescheduleV1Schema = z.object({
  startsAt: z.iso.datetime({ offset: true }),
  endsAt: z.iso.datetime({ offset: true }),
  timezone: z.string().min(1).max(64),
  reason: z.string().trim().min(1).max(500),
}).strict().refine((value) => value.startsAt < value.endsAt, {
  path: ["endsAt"],
  message: "Visit must end after it starts.",
})

export const visitCancelV1Schema = z.object({
  reason: z.string().trim().min(1).max(500),
}).strict()

export const visitCalendarQueryV1Schema = z.object({
  view: z.enum(["day", "week", "team"]),
  startsAt: z.iso.datetime({ offset: true }),
  endsAt: z.iso.datetime({ offset: true }),
  workerId: entityIdSchema.nullable(),
  crewId: entityIdSchema.nullable(),
  limit: z.number().int().min(1).max(500),
}).strict().refine((value) => value.startsAt < value.endsAt, {
  path: ["endsAt"],
  message: "Calendar window must increase.",
})
